import { IThemeBreakpoints } from '../types/theme';

const breakpoints: IThemeBreakpoints = {
  largeDesktop: 1660,
  desktop: 1320,
  largeTablet: 1080,
  tablet: 768,
  mobile: 560,
  smallMobile: 375,
};

export const getMinSizeMedia = (size: keyof IThemeBreakpoints) => `${breakpoints[size] + 1}px`;

export const min = (size: keyof IThemeBreakpoints) => `(min-width: ${getMinSizeMedia(size)})`;
export const max = (size: keyof IThemeBreakpoints) => `(max-width: ${breakpoints[size]}px)`;
export const minMax = (sizeMin: keyof IThemeBreakpoints, sizeMax: keyof IThemeBreakpoints) =>
  `(min-width: ${getMinSizeMedia(sizeMin)}) and (min-width: ${breakpoints[sizeMax]}px)`;

export default breakpoints;
